
import React from 'react';
import { FacilityOrderTemplatePNMissingInformationModalTemplate } from 'themes/application/facility-order/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplatePNMissingInformationModalStore } from 'application/facility-order/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplatePNMissingInformationModalStore(rootStore, componentProps), 'facilityOrderTemplatePNMissingInformationModalStore')
@observer
class FacilityOrderTemplatePNMissingInformationModal extends React.Component {
    render() {
        return <FacilityOrderTemplatePNMissingInformationModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplatePNMissingInformationModal;
